<template>
  <div class="purchase">
    <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
      <div class="complementary hidden-sm-and-up">
        <el-collapse accordion v-model="accordionOpen">
          <el-collapse-item name="accordion">
            <template slot="title">
              <svg width="20" height="19" xmlns="http://www.w3.org/2000/svg" class="order-summary-toggle__icon">
                <path
                  d="M17.178 13.088H5.453c-.454 0-.91-.364-.91-.818L3.727 1.818H0V0h4.544c.455 0 .91.364.91.818l.09 1.272h13.45c.274 0 .547.09.73.364.18.182.27.454.18.727l-1.817 9.18c-.09.455-.455.728-.91.728zM6.27 11.27h10.09l1.454-7.362H5.634l.637 7.362zm.092 7.715c1.004 0 1.818-.813 1.818-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817zm9.18 0c1.004 0 1.817-.813 1.817-1.817s-.814-1.818-1.818-1.818-1.818.814-1.818 1.818.814 1.817 1.818 1.817z"></path>
              </svg>
              <span v-if="this.accordionOpen === 'accordion'"><span>{{ $t('hideOrderSummary') }}</span></span>
              <span v-else>{{ $t('showOrderSummary') }}</span>
              <span class="order-summary-toggle__total-recap total-recap">
                <span class="total-recap__final-price">${{this.GrandTotal}}</span>
              </span>
            </template>
            <div class="sidebar hidden-sm-and-up">
              <div class="sidebar__header"></div>
              <div class="sidebar__content">
                <div class="order-summary order-summary--is-collapsed">
                  <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
                  <div class="order-summary__sections">
                    <div class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable">
                      <div class="order-summary__section__content">
                        <table class="product-table">
                          <tr class="product" v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                            <td class="product__image" @click="goToProductDetail(item)">
                              <div class="product-thumbnail">
                                <div class="product-thumbnail__wrapper">
                                  <img :src="item.Thumbnail" alt="">
                                </div>
                                <span class="product-thumbnail__quantity">{{item.Quantity}}</span>
                              </div>
                            </td>
                            <th class="product__description">
                          <span v-if='$i18n.locale=="en"' class="product__description__name order-summary__emphasis">
                            {{item.Name}}
                          </span>
                          <span v-if='$i18n.locale=="ch"' class="product__description__name order-summary__emphasis">
                            {{item.Description}}
                          </span>
                              <span class="product__description__variant order-summary__small-text"></span>
                            </th>
                            <td class="product__price">
                              <span class="order-summary__emphasis">
                                ${{item.TotalPrice.toFixed(2)}}
                              </span>
                            </td>
                          </tr>

                        </table>
                        <div style="display: none" class="order-summary__scroll-indicator">
                          {{ $t('scrollMoreItems') }}
                          <i class="el-icon-bottom"></i>
                        </div>
                      </div>
                    </div>
                    <div v-if="!this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid" class="order-summary__section order-summary__section--discount">
                      <div class="discount" :class="'promoCode' ? 'discountCode' : ''">
                        <el-form-item label="Discount code">
                          <el-input v-model="promoCode"
                            ></el-input>
                        </el-form-item>
                        <el-button @click="validatePromotionCode($event)" class="field__input-btn btn">
                          <span class="btn__content visually-hidden-on-mobile">{{ $t('apply') }}</span>
                        </el-button>
                      </div>
                    </div>
                    <div class="promocode-successful" v-else-if="this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid">
                      <h3>{{ $t('promoApplied') }}</h3>
                    </div>
                    <div v-else-if="this.promoCodeValid && !this.promoCodeSuccessful && !this.promoCodeLoading" class="order-summary__section order-summary__section--discount">
                      <div class="discount" :class="promoCode ? 'discountCode' : ''">
                        <el-form-item label="Discount code">
                          <el-input v-model="promoCode"></el-input>
                        </el-form-item>
                        <el-button @click="validatePromotionCode($event)" class="field__input-btn btn">
                          <span>{{ $t('inputValidPromo') }}</span>
                          <!-- Leaving the below button in case myumyu dislikes the new version. -->
                          <!-- <span class="btn__content visually-hidden-on-mobile">Apply</span> -->
                        </el-button>
                      </div>
                    </div>
                    <div class="order-summary__section order-summary__section--total-lines">
                      <table class="total-line-table">
                        <tbody class="total-line-table__tbody">
                        <tr class="total-line total-line--subtotal">
                          <th class="total-line__name">
                            {{ $t('subtotal') }}
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          ${{this.TotalPrice.toFixed(2)}}
                        </span>
                          </td>
                        </tr>
                        <tr class="total-line total-line--shipping">
                          <th class="total-line__name">
                            <span>{{ $t('shipping_fee') }}</span>
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__small-text">
                          ${{this.$store.state.cart.necessaryCartItems.Delivery}}
                        </span>
                          </td>
                        </tr>
                          <tr class="total-line total-line--subtotal">
                          <th class="total-line__name">
                            {{ $t('tax') }}
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          ${{this.necessaryCartItems.Tax}}
                        </span>
                          </td>
                        </tr>
                          <tr class="total-line total-line--subtotal">
                          <th class="total-line__name">
                            {{ $t('promotion') }}
                          </th>
                          <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          -${{this.Savings.toFixed(2)}}
                        </span>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="total-line-table__footer">
                        <tr class="total-line">
                          <th class="total-line__name total_name payment-due-label">
                      <span class="payment-due-label__total">
                        {{ $t('total') }}
                      </span>
                            <span class="payment-due-label__taxes order-summary__small-text hidden">
                        {{ $t('including') }}
                        <span class="">$0.00</span>
                        {{ $t('tax') }}
                      </span>
                          </th>
                          <td class="total-line__price usd_price payment-due">
                        <span class="payment-due__currency">
                          USD
                        </span>
                            <span class="payment-due__price">${{this.GrandTotal}}</span>
                          </td>
                        </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="wrap">
        <div class="main">
          <header class="main__header">
            <h2 class="section__title">{{ $t('deliveryTime') }}</h2>
            <div class="timeslots" >
              <div v-for="times in timeSlots">
                <el-radio style="border: 0; width: 100%; height: 1em;" :disabled="times.available==false" v-model="deliveryTime" :label="times.value" ><span>{{ times.name }}</span></el-radio>
              </div>
            </div>
          </header>
          <main class="main__content">
            <div class="step__sections">
              <div class="section section--shipping-address ">
                <div class="addAddress">
                  <div class="section__header__purchase">
                    <h2 class="section__title" style="marginBottom: 10px">{{ $t('deliveryInfo') }}</h2>
                    <div class="delivery_info__warning">
                      <span>{{ $t('deliveryInfoWarning') }}</span>
                    </div>
                    <div v-if="!this.checkoutWithinRadius && addressChoice" class="time_tip__purchase">
                      <span class="error-message">{{ $t('notInArea') }}</span>
                    </div>
                    <div v-if="!addressChoice" class="time_tip"><span>{{ $t('selectAddress') }}</span></div>
                  </div>
                  <div style="marginBottom: 1em" class="address-container" v-if="addresses.length > 0">
                    <div style="margin: 0.2em" v-for="address in addresses">
                      <el-radio @change="validateDeliveryRadiusCheckout($event)" v-model="addressChoice" :label="address" :disabled="shipstationLoading">
                        <div class="next-line">
                          <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                        </div>
                      </el-radio>
                    </div>
                  </div>
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title" :class="isAddAddress?'':'bg_none'" @click="addAddress">
                      <i :class="isAddAddress?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addNewAddress') }}</span>
                    </div>
                    <div class="fieldset" v-show="isAddAddress">
                      <div class="field">
                        <!--地址信息-->
                        <div class="two">
                          <div :class="firstName?'firstName':''" class="width">
                            <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                              <el-input v-bind:placeholder="$t('firstName')" v-model="sizeForm.firstName"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                          <div :class="lastName?'lastName':''" class="width">
                            <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                              <el-input v-bind:placeholder="$t('lastName')" v-model="sizeForm.lastName"
                                        @keyup.native="contact"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <div :class="address?'address':''">
                          <el-form-item v-bind:label="$t('address')" prop="address">
                            <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="sizeForm.address"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                        </div>
                        <div class="address">
                          <div class="width" :class="phone?'phone':''">
                            <el-form-item v-bind:label="$t('phone')" prop="phone">
                              <el-input v-bind:placeholder="$t('mobilePhone')" v-model="sizeForm.phone"
                                        @keyup.native="contact"></el-input>

                              <!--<el-tooltip class="item" effect="dark" content="In case we need to contact you about your order" placement="top">-->
                              <!--<i class="el-icon-question"></i>-->
                              <!--</el-tooltip>-->

                            </el-form-item>
                          </div>
                        </div>
                        <div :class="city?'city':''">
                          <el-form-item v-bind:label="$t('city')" prop="city">
                            <el-input v-bind:placeholder="$t('city')" v-model="sizeForm.city"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                        </div>
                        <div class="three">
                          <div class="width_30">
                            <div class="city">
                              <el-form-item v-bind:label="$t('country')" prop="Country">
                                <el-select v-model="sizeForm.Country" value="">
                                  <el-option
                                    v-for="item in CountryList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="width_30">
                            <div class="city">
                              <el-form-item v-bind:label="$t('state')" prop="State">
                                <el-select v-model="sizeForm.State" v-bind:placeholder="$t('pleaseSelect')" value="">
                                  <el-option
                                    v-for="item in stateOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="width_30">
                            <div :class="code?'code':''">
                              <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                <el-input v-bind:placeholder="$t('zipCode')" v-model="sizeForm.code"
                                          @keyup.native="contact"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </div>
                        <!--单选开始-->
                        <!-- <div class="checkbox-wrapper">
                          <el-checkbox v-model="sizeForm.subscribe">Save this information for next time</el-checkbox>
                        </div> -->
                        <!--end单选结束-->
                        <!--end地址信息-->
                        <!--确认地址-->
                        <!-- <div class="section__content_address">
                          <p class="p_top">Is this address a shared community, apartment or dorm?</p>
                          <el-radio-group v-model="sizeForm.confirmAddress" @change="ifAddress">
                            <el-radio :label="1">Yes</el-radio>
                            <el-radio :label="2">No</el-radio>
                          </el-radio-group> -->

                          <!--<transition name="fade" enter-active-class="fadeInDown">-->
                          <!-- <div v-if="sizeForm.confirmAddress===1" class="yes">
                            <p class="yes_title">Drop off options</p>
                            <el-radio-group v-model="sizeForm.whether" @change="whetherNum">
                              <el-radio :label="1">Deliver to door</el-radio>
                              <el-radio :label="2">Pick up at the gate</el-radio>
                            </el-radio-group>

                            <div v-if="sizeForm.whether===1" class="Deliver">
                              <span>Instrction for driver to pass through the gate</span>
                              <el-input
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 8}"
                                placeholder="For example:gate code"
                                resize="none"
                                v-model="sizeForm.gateCode">
                              </el-input>
                              <div class="checkbox-wrapper">
                                <el-checkbox v-model="sizeForm.frontDoor">leave at front door</el-checkbox>
                              </div>
                            </div>
                            <div v-if="sizeForm.whether===2" class="Pick">
                              <p>* We will send you a text message when our driver is approaching.</p>
                              <p>Please ensure someone is present for pickup.</p>
                            </div>
                          </div> -->
                          <!--</transition>-->
                          <!--<transition name="fade" enter-active-class="fadeInDown">-->
                          <!-- <div v-if="sizeForm.confirmAddress===2" class="yes">
                            <div class="Deliver No">
                              <span>Delivery Instruction</span>
                              <el-input
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 8}"
                                placeholder="Addtional delivery instructions to find the address."
                                resize="none"
                                v-model="sizeForm.gateCode">
                              </el-input>
                              <div class="checkbox-wrapper">
                                <el-checkbox v-model="sizeForm.frontDoor">leave at front door</el-checkbox>
                              </div>
                            </div>
                          </div> -->
                          <!--</transition>-->
                        <!-- </div> -->
                        <!--end确认地址-->
                        <button class="place btn" @click="postNewAddress(sizeForm, 'shipping', $event)">{{ $t('saveAddress') }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="addPayment">
                  <div class="section__header">
                    <h2 class="section__title"></h2>
                  </div>
                  <!-- <header class="main__header hidden-sm-and-down"> -->
                  <h2 class="section__title">{{ $t('choosePaymentMethod') }}</h2>
                  <div v-show="((!this.checkoutWithinRadius && addressChoice) || !addressChoice) && showPaymentError" class="time_tip__purchase">
                    <span class="error-message">{{ $t('chooseValidAddressPay') }}</span>
                  </div>
                  <div class="payment-container" v-bind:style="{marginBottom: 10 + 'px'}">
                    <div v-if="(!this.checkoutWithinRadius && addressChoice) || !addressChoice" @click="showPaymentError=true">
                      <el-radio className="radio-purchase" :disabled="(!this.checkoutWithinRadius && addressChoice) || !addressChoice" v-model="paymentMethod" v-bind:label="$t('alipay')"><span><i class="fab fa-alipay fa-3x" style="color: #C0C4CC;"></i></span></el-radio>
                      <el-radio className="radio-purchase" :disabled="(!this.checkoutWithinRadius && addressChoice) || !addressChoice" v-model="paymentMethod" v-bind:label="$t('wechatpay')"><span><i class="fab fa-weixin fa-3x" style="color: #C0C4CC;"></i></span></el-radio>
                      <el-radio className="radio-purchase" :disabled="(!this.checkoutWithinRadius && addressChoice) || !addressChoice" v-model="paymentMethod" v-bind:label="$t('creditcard')"><span><i class="far fa-credit-card fa-3x" style="color: #C0C4CC;"></i></span></el-radio>
                    </div>
                    <div v-else>
                      <el-radio className="radio-purchase" v-model="paymentMethod" label="alipay"><span><i class="fab fa-alipay fa-3x"></i></span></el-radio>
                      <el-radio className="radio-purchase" v-model="paymentMethod" label="wechatpay"><span><i class="fab fa-weixin fa-3x"></i></span></el-radio>
                      <el-radio className="radio-purchase" v-model="paymentMethod" label="creditcard"><span><i class="far fa-credit-card fa-3x"></i></span></el-radio>
                    </div>
                  </div>
                  <!-- </header> -->
                  <div v-if="paymentMethod === 'creditcard' && !this.cardLoading" class="section__content">
                    <div class="title" :class="isAddPayment?'':'bg_none'" @click="isAddPayment = !isAddPayment">
                      <i :class="isAddPayment?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addPayment') }}</span>
                    </div>
                    <div class="fieldset" v-show="isAddPayment">
                      <div class="field">
                        <!--地址信息-->

                        <a v-if="this.savedCards.length && !this.saveCreditCard" class="time_tip">Select a saved credit card.</a>
                        <div style="marginBottom: 1em" class="address-container" v-if="savedCards.length > 0">
                          <div style="margin: 0.2em" v-for="card in savedCards">
                            <el-radio v-model="savedCard" :label="card">
                              <div class="next-line">
                                <span>{{card.cardType}} : {{card.cardNumber}}</span>
                              </div>
                            </el-radio>
                          </div>
                        </div>
                        <el-checkbox v-model="saveCreditCard">
                          Save card for future use
                        </el-checkbox>
                        <div>
                          <el-form-item v-bind:label="$t('cardHolderName')" prop="card_holder_name">
                            <el-input v-bind:placeholder="$t('cardHolderName')" v-model="sizeForm.card_holder_name"
                                      @keyup.native="contact"></el-input>
                          </el-form-item>
                          </div>
                          <div>
                            <el-form-item v-bind:label="$t('creditCardNumber')" prop="Card">
                              <el-input
                                v-bind:placeholder="$t('creditCardNumber')"
                                v-model="sizeForm.Card"
                                @keyup.native="contact"
                                @input="cardNumberFormatter(sizeForm.Card)"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="two">
                            <div class="width">
                              <el-form-item v-bind:label="$t('cardExpiration')" prop="Expiration">
                                <el-input
                                  v-bind:placeholder="$t('cardExpiration')"
                                  v-model="sizeForm.Expiration"
                                  @keyup.native="contact"
                                  @input="cardExpireDateFormatter(sizeForm.Expiration)"
                                  :maxlength="5"
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="width">
                              <el-form-item v-bind:label="$t('cvc')" prop="CVC">
                                <el-input v-bind:placeholder="$t('cvc')" v-model="sizeForm.CVC" :maxlength="4"
                                          @keyup.native="contact"></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="billing_address_selection">
                            <div class="time_tip"><span>{{ $t('selectBillingAddress') }}</span></div>
                            <el-checkbox v-model="billingAddressSame">{{ $t('same_as_shipping') }}</el-checkbox>
                        </div>
                        <div v-if="!billingAddressSame && addresses.length > 0" style="marginBottom: 1em" class="address-container"
                          >
                          <div style="margin: 0.2em" v-for="address in addresses">
                            <el-radio @change="validateDeliveryRadiusCheckout($event)" v-model="billingAddress" :label="address">
                              <div class="next-line">
                                <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                              </div>
                            </el-radio>
                          </div>
                        </div>
                        <div v-if="!billingAddressSame" class="addAddress">
                          <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                            <div class="title" :class="isAddBilling?'':'bg_none'" @click="addBilling">
                              <i :class="isAddBilling?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addNewAddress') }}</span>
                            </div>
                            <div class="fieldset" v-show="isAddBilling">
                              <div class="field">
                                  <div class="two">
                                    <div :class="firstName?'firstName':''" class="width">
                                      <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                                        <el-input v-bind:placeholder="$t('firstName')" v-model="sizeForm.firstName"
                                                  @keyup.native="contact"></el-input>
                                      </el-form-item>
                                    </div>
                                    <div :class="lastName?'lastName':''" class="width">
                                      <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                                        <el-input v-bind:placeholder="$t('lastName')" v-model="sizeForm.lastName"
                                                  @keyup.native="contact"></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                  <div :class="address?'address':''">
                                    <el-form-item v-bind:label="$t('address')" prop="address">
                                      <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="sizeForm.address"
                                                @keyup.native="contact"></el-input>
                                    </el-form-item>
                                  </div>
                                  <div class="address">
                                    <div class="width" :class="phone?'phone':''">
                                      <el-form-item v-bind:label="$t('phone')" prop="phone">
                                        <el-input v-bind:placeholder="$t('phone')" v-model="sizeForm.phone"
                                                  @keyup.native="contact"></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                  <div :class="city?'city':''">
                                    <el-form-item v-bind:label="$t('city')" prop="city">
                                      <el-input v-bind:placeholder="$t('city')" v-model="sizeForm.city"
                                                @keyup.native="contact"></el-input>
                                    </el-form-item>
                                  </div>
                                  <div class="three">
                                    <div class="width_30">
                                      <div class="city">
                                        <el-form-item v-bind:label="$t('country')" prop="Country">
                                          <el-select v-model="sizeForm.Country" value="">
                                            <el-option
                                              v-for="item in CountryList"
                                              :key="item.value"
                                              :label="item.label"
                                              :value="item.value"
                                            >
                                            </el-option>
                                          </el-select>
                                        </el-form-item>
                                      </div>
                                    </div>
                                    <div class="width_30">
                                      <div class="city">
                                        <el-form-item v-bind:label="$t('state')" prop="State">
                                          <el-select v-model="sizeForm.State" v-bind:placeholder="$t('pleaseSelect')" value="">
                                            <el-option
                                              v-for="item in stateOptions"
                                              :key="item.value"
                                              :label="item.label"
                                              :value="item.value"
                                            >
                                            </el-option>
                                          </el-select>
                                        </el-form-item>
                                      </div>
                                    </div>
                                    <div class="width_30">
                                      <div :class="code?'code':''">
                                        <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                          <el-input v-bind:placeholder="$t('zipCode')" v-model="sizeForm.code"
                                                    @keyup.native="contact"></el-input>
                                        </el-form-item>
                                      </div>
                                    </div>
                                  </div>
                                <button class="place btn" @click="postNewAddress(sizeForm, 'billing', $event)">{{ $t('saveBillingAddress') }}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span v-show="cardError" style="color:red">{{cardError}}</span>
                        <el-button @click="fetchCardToken()" class="place btn " >{{ $t('submitCardInfo') }}</el-button>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="this.cardLoading" class="svg">
                      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path fill="#ff6f37" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                          <animateTransform attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="1s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    </div>
                    <!-- <div v-else-if="!this.cardLoading && this.cardSuccess"><h3>{{ $t('cardSubmitSuccess') }}</h3></div> -->
                  </div>
                  <span v-show="cardError" style="color:red">{{cardError}}</span>
                </div>
              </div>
          </main>
          <footer class="main__footer" v-if="this.necessaryCartItems.AvailableCredit !== 0">
            <h2 class="section__title hidden-sm-and-down">{{ $t('userCredit') }}</h2>
              <div style="marginTop: 20px; marginBottom: 20px">
                <el-checkbox v-model="IsCreditUsed" :disabled="!addressChoice || !this.checkoutWithinRadius"></el-checkbox>
                <span style="marginLeft: 10px; fontSize: 17px">{{ $t('use_my_credit_balance') }} <span style="color: red">(${{this.necessaryCartItems.AvailableCredit}})</span></span>
              </div>
          </footer>
          <footer v-if="!this.promoCodeLoading && !this.promoCodeSuccessful &&!this.promoCodeValid" class="main__footer">
            <h2 class="section__title hidden-sm-and-down">{{ $t('discount') }}</h2>
              <div class="discount hidden-sm-and-down" :class="promoCode ? 'discountCode' : ''">
                <el-form-item v-bind:label="$t('discountCode')" >
                  <el-input v-bind:placeholder="$t('discountCode')" v-model="promoCode"
                            @keyup.native="contact" ></el-input>
                </el-form-item>
                <button class="place btn" @click="validatePromotionCode($event)">{{ $t('apply') }}</button>
              </div>
              <!-- <div class="checkbox-wrapper hidden-sm-and-down">
                <el-checkbox v-model="sizeForm.subscribe"><p>Use ${{0.00}} of your ${{0.00}} gift card balance - <span>${{0.00}}</span> </p></el-checkbox>
              </div> -->
              <el-button :disabled="!isFormValidForSubmission()" @click="onSubmit('sizeForm')" class="place btn hidden-sm-and-up" >{{ $t('placeOrder') }}</el-button>
                <div class="hidden-sm-and-up" v-if="this.orderFailed">
                  <span class="error-message">
                    Error: {{this.orderFailMessage}}
                  </span>
                </div>
          </footer>
          <div v-else-if="this.promoCodeLoading && !this.promoCodeSuccessful" class="svg">
            <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
              <path fill="#ff6f37" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                <animateTransform attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          </div>
          <div v-else-if="this.promoCodeSuccessful && !this.promoCodeLoading &&! this.promoCodeValid">
            <el-button
              :disabled="!isFormValidForSubmission()"
              @click="onSubmit('sizeForm')"
              class="place btn hidden-sm-and-up"
            >
              {{ $t('placeOrder') }}
            </el-button>
            <h3 class="hidden-sm-and-down">Promo code successful</h3>
          </div>
          <div v-else-if="this.promoCodeValid && !this.promoCodeSuccessful && !this.promoCodeLoading">
            <div class="discount hidden-sm-and-down" :class="promoCode ? 'discountCode' : ''">
              <el-form-item v-bind:label="$t('discountCode')" >
                <el-input v-bind:placeholder="$t('discountCode')" v-model="promoCode"
                  @keyup.native="contact" ></el-input>
              </el-form-item>
              <button class="place btn" @click="validatePromotionCode($event)">{{ $t('apply') }}</button>
            </div>
            <span>{{ this.promoCodeValid}}</span>
            <el-button
              :disabled="!isFormValidForSubmission()"
              @click="onSubmit('sizeForm')"
              class="place btn hidden-sm-and-up"
            >
              {{ $t('placeOrder') }}
            </el-button>
          </div>
        </div>
        <div class="sidebar hidden-sm-and-down">
          <div class="sidebar__header"></div>
            <div class="sidebar__content">
              <div class="order-summary order-summary--is-collapsed">
                <h2 class="visually-hidden-if-js">{{ $t('orderSummary') }}</h2>
                <div class="order-summary__sections">
                  <div class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable" ref="infoBox">
                    <div class="order-summary__section__content">
                      <table class="product-table">
                        <tr class="product" v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines">
                          <td @click="goToProductDetail(item)" class="product__image">
                            <div class="product-thumbnail">
                              <div class="product-thumbnail__wrapper">
                                <img :src="item.Thumbnail" alt="">
                              </div>
                              <span class="product-thumbnail__quantity">{{item.Quantity}}</span>
                            </div>
                          </td>
                          <th class="product__description">
                            <span v-if='$i18n.locale=="en"' class="product__description__name order-summary__emphasis">
                              {{item.Name}}
                            </span>
                            <span v-if='$i18n.locale=="ch"' class="product__description__name order-summary__emphasis">
                              {{item.Description}}
                            </span>
                            <span class="product__description__variant order-summary__small-text"></span>
                          </th>
                          <td class="product__price">
                            <span class="order-summary__emphasis">
                              ${{item.TotalPrice.toFixed(2)}}
                            </span>
                          </td>
                        </tr>
                      </table>
                      <div style="display: none" class="order-summary__scroll-indicator">
                        {{ $t('scrollMoreItems') }}
                        <i class="el-icon-bottom"></i>
                      </div>
                    </div>
                  </div>
                  <div v-if="this.$store.state.cart.necessaryCartItems.Promotions.length > 0" class="order-summary__section order-summary__section--product-list order-summary__section--is-scrollable" ref="promoInfoBox">
                    <div class="promo-summary__section__content">
                    <p class="promo-summary__small-text">{{ $t('promotion') }}</p>
                        <table class="product-table">
                        <tr class="product" v-for="(item,index) in this.$store.state.cart.necessaryCartItems.Promotions">
                          <td @click="goToProductDetail(item)" class="product__image">
                            <div class="product-thumbnail">
                              <div class="product-thumbnail__wrapper">
                                <img :src="item.Thumbnail" alt="">
                              </div>
                              <span class="product-thumbnail__quantity">{{item.Quantity}}</span>
                            </div>
                          </td>
                          <th class="product__description">
                            <span v-if='$i18n.locale=="en"' class="product__description__name order-summary__emphasis">
                              {{item.Name}}
                            </span>
                            <span v-if='$i18n.locale=="ch"' class="product__description__name order-summary__emphasis">
                              {{item.Description}}
                            </span>
                            <span class="product__description__variant order-summary__small-text"></span>
                          </th>
                          <td class="product__price">
                            <span class="promo-summary__free">
                            {{ $t('free') }}
                             </span>
                          </td>
                        </tr>
                      </table>
                      <div style="display: none" class="order-summary__scroll-indicator">
                        {{ $t('scrollMoreItems') }}
                        <i class="el-icon-bottom"></i>
                      </div>
                    </div>
                  </div>
                  <div class="order-summary__section order-summary__section--total-lines"  :class="(scrollPosition < '-110') ? 'fixPosition':'' " >
                    <table class="total-line-table">
                      <tbody class="total-line-table__tbody">
                      <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('subtotal') }}
                        </th>
                        <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            ${{this.TotalPrice.toFixed(2)}}
                          </span>
                        </td>
                      </tr>
                      <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          Tax
                        </th>
                        <td class="total-line__price">
                          <span class="order-summary__emphasis">
                            ${{this.necessaryCartItems.Tax}}
                          </span>
                        </td>
                      </tr>
                      <tr class="total-line total-line--shipping">
                        <th class="total-line__name" style="paddingRight: 0">
                          <span>{{ $t('shipping_fee') }}</span>
                          <span class="shipping-note" v-show="this.TotalPrice.toFixed(2)<20">{{ $t('reach20') }}</span>
                        </th>
                        <td class="total-line__price">
                          <span class="order-summary__small-text">
                            ${{this.$store.state.cart.necessaryCartItems.Delivery.toFixed(2)}}
                          </span>
                        </td>
                      </tr>
                      <tr class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('promotion') }}
                        </th>
                        <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          -${{this.Savings.toFixed(2)}}
                        </span>
                        </td>
                      </tr>
                      <tr v-if="this.IsCreditUsed === true" class="total-line total-line--subtotal">
                        <th class="total-line__name">
                          {{ $t('credit') }}
                        </th>
                        <td class="total-line__price">
                        <span class="order-summary__emphasis">
                          -${{this.necessaryCartItems.CreditAmount}}
                        </span>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="total-line-table__footer">
                      <tr class="total-line">
                      <th class="total-line__name total_name payment-due-label">
                      <span class="payment-due-label__total">
                        {{ $t('total') }}
                      </span>
                        <span class="payment-due-label__taxes order-summary__small-text hidden">
                        {{ $t('including') }}
                        <span class="">$0.00</span>
                        {{ $t('tax') }}
                      </span>
                      </th>
                      <td class="total-line__price usd_price payment-due">
                        <span class="payment-due__currency">
                          USD
                        </span>
                        <span class="payment-due__price">${{this.GrandTotal}}</span>
                      </td>
                    </tr>
                    </tfoot>
                  </table>
                  <el-button :disabled="!isFormValidForSubmission()" @click="onSubmit('sizeForm')" class="place btn" style="marginTop: 50px;">{{ $t('placeOrder') }}</el-button>
                  <div v-if="this.orderFailed">
                    <span class="error-message">
                      Error: {{this.orderFailMessage}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--提示框-->
      <div class="refundContent">
        <el-dialog
          title="Refund policy"
          :visible.sync="this.refund"
          width="90%"
          :before-close="refundShow">
          <p>Refund Policy</p>
          <p>A refund, or credit, for the cost of unopened merchandise, less a 15% restocking fee, will be issued when
            merchandise is returned within 10 days of receipt. Shipping cost will only be refunded if the return is due to
            an error made by J Town Express.</p>
          <p>Please note: J Town Express is not responsible for items opened or damaged due to high pressure/altitude.
            These items will not be refunded or accepted for return.</p>
          <p>Out of Stock Items</p>
          <p>Due to J Town Express's large variety of items and constant volume of sales, occasionally, items listed for
            sale on the e-store may be out of stock. J Town Express will issue an immediate refund for items ordered but
            currently not in stock.</p>
        </el-dialog>
      </div>
      <div class="privacyContent">
        <el-dialog
          title="Privacy policy"
          :visible.sync="this.privacy"
          width="90%"
        >
          <p>Privacy Notice</p>
          <p>This privacy notice discloses the privacy practices for jtownexpress.com. This privacy notice applies solely
            to information collected by this web site. It will notify you of the following:</p>
          <p>What personally identifiable information is collected from you through the web site, how it is used and with
            whom it may be shared.</p>
          <p>What choices are available to you regarding the use of your data.</p>
          <p>The security procedures in place to protect the misuse of your information. How you can correct any
            inaccuracies in the information.</p>
          <p>Information Collection, Use, and Sharing</p>
          <p>We are the sole owners of the information collected on this site. We only have access to/collect information
            that you voluntarily give us via email or other direct contact from you. We will not sell or rent this
            information to anyone.</p>
          <p>We will use your information to respond to you, regarding the reason you contacted us. We will not share your
            information with any third party outside of our organization, other than as necessary to fulfill your request,
            e.g. to ship an order.</p>
          <p>Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products
            or services, or changes to this privacy policy.</p>
          <p>Your Access to and Control Over Information</p>
          <p>You may opt out of any future contacts from us at any time. You can do the following at any time by
            contacting us via the email address or phone number given on our website:</p>
          <p>See what data we have about you, if any.</p>
          <p>Change/correct any data we have about you.</p>
          <p>Have us delete any data we have about you.</p>
          <p>Express any concern you have about our use of your data.</p>
          <p>Security</p>
          <p>We take precautions to protect your information. When you submit sensitive information via the website, your
            information is protected both online and offline.</p>
          <p>Wherever we collect sensitive information (such as credit card data), that information is encrypted and
            transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your
            web browser, or looking for "https" at the beginning of the address of the web page.</p>
          <p>While we use encryption to protect sensitive information transmitted online, we also protect your information
            offline. Only employees who need the information to perform a specific job (for example, billing or customer
            service) are granted access to personally identifiable information. The computers/servers in which we store
            personally identifiable information are kept in a secure environment.</p>
          <p>If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone
            at (888) 482-2742 or via email.</p>
        </el-dialog>
      </div>
      <!--end提示框-->
    </el-form>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { validateZipCode, validatePhoneNumber } from "../../config/validation";
import moment from "moment";
import addresses from '../store/modules/addresses';
  export default {
    name: "purchase",
    data() {
      return {
        isAddBilling: false,
        addressSelection: null,
        scrollPosition: null,
        accordionOpen: 'accordion',
        labelPosition: 'top',
        address: '',
        promoCode: '',
        card_holder_name: '',
        addressChoice: '',
        order: false,
        radio: '', // 单选框默认
        deliveryTime: '',
        creditCardSuccess: false,
        savedCard: {},
        formLabelAlign: {
          name: '',
          password: '',
        },
        showPaymentError: false,
        paymentMethod: '',
        activeNames: ['1'],
        Subtotal:15,
        total:15,
        billingAddress: '',
        billingAddressSame: true,
        // 表单默认数据
        sizeForm: {
          name: "",
          subscribe: true,//是否订阅
          firstName: '',//名字
          lastName: '',//名字
          address: '',//地址
          apartment: '',//地址
          city: '',//城市
          code: '',//编码
          phone: '',//联系方式
          Country: 'United States', //国家/地区
          State: 'CA',//地区
          gateCode: '',//送货上门详细地址
          whether: 1,//是否确认
          confirmAddress: '',//确认地址
          Card: '',//卡号
          Expiration: '',//到期时间
          CVC: '',//安全码
          storage: true,//是否保存信息
          card_holder_name: '',
        },
        cardData: {
          cardNumber: null,
          expiry: null,
          cvc: null,
          // cardType: null,
          CardName: null,
          salesOrderId: null,
        },
        saveCreditCard: false,
        rules:{
          firstName:[
            { required: true, message: 'First Name is Required', trigger: 'blur' },
            { min: 2, max: 20, message: 'first name length at least 3', trigger: 'blur' }
          ],
          lastName:[
            { required: true, message: 'Last Name is Required', trigger: 'blur' },
            { min: 2, max: 20, message: 'last name length at least 3', trigger: 'blur' }
          ],
          address:[
            { required: true, message: 'Address is required', trigger: 'blur' },
            { min: 2, max: 30, message: 'address length at least 3', trigger: 'blur' }
          ],
          city:[
            { required: true, message: 'City is Required', trigger: 'blur' },
            { min: 3, max: 20, message: 'city length at least 3', trigger: 'blur' }
          ],
          code:[
            { required: true, message: 'Zip Code is Required', trigger: 'blur' },
            { min: 3, max: 5, message: 'code length at least 3', trigger: 'blur' }
          ],
          phone:[
            { required: true, message: 'Phone Number is Required', trigger: 'blur' },
            { min: 3, max: 12, message: 'phone length at least 3', trigger: 'blur' }
          ],
          Country:[
            { required: true, message: 'Country is Required', trigger: 'blur' },
            { min: 3, max: 20, message: 'Country length at least 3', trigger: 'blur' }
          ],
          Card:[
            { required: true, message: 'Card Info is Required', trigger: 'blur' },
            { min: 16, max: 23, message: 'Card number should be 13 - 19 digits', trigger: 'blur' },
          ],
          Expiration:[
            { required: true, message: 'Expiration Date is Required', trigger: 'blur' },
            { min: 5, max: 5, message: 'Expiration data shoud be in format MM/YY', trigger: 'blur' }
          ],
          CVC:[
            { required: true, message: 'Security Code is Required', trigger: 'blur' },
            { min: 3, max: 4, message: 'CVC length at least 3', trigger: 'blur' }
          ],
        },
        //下拉框默认数据
        stateOptions: this.$store.state.addresses.states, // States drop down data
        CountryList:[{
          value: '',
          label: '---'
        }, {
          value: 'United States',
          label: 'United States'
        }],

        // input label
        input_label: false,
        firstName: false,
        lastName: false,
        addressName: '',
        apartment: false,
        city: false,
        code: false,
        phone: false,
        privacy: false,
        refund: false,
        // end input label

        //商品列表默认数据
        isAddAddress: false,//展示添加地址
        isAddPayment: false,//展示添加支付方式

        //user credit
        IsCreditUsed: false,
        existingBankAccountId: null,
      }
    },
    methods: {
      ...mapMutations('products', ['updateActiveProduct']),
      ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard', 'updatePromoCode']),
      ...mapActions('checkout', ['fetchAchProfiles']),
        cardNumberFormatter(value) {
        var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
        var matches = v.match(/\d{4,19}/g);
        var match = matches && matches[0] || ''
        var parts = []

        for (var i=0, len=match.length; i<len; i+=4) {
            parts.push(match.substring(i, i+4))
        }
        if (parts.length) {
            this.sizeForm.Card =  parts.join(' ')
        } else {
            this.sizeForm.Card = value
        }
      },
      cardExpireDateFormatter(date) {
        if(date.length == 3) {
          if(date[date.length - 1] !== '/') {
            var temp =  this.sizeForm.Expiration.split('');
            temp.splice(2, 0, '/');
            this.sizeForm.Expiration = temp.join('');
            return;
          }else {
            this.sizeForm.Expiration = this.sizeForm.Expiration.slice(0, 2);
          }
        }
      },
      contact(el) {
        this.sizeForm.name !== '' ? this.input_label = true : this.input_label = false;
        this.sizeForm.firstName !== '' ? this.firstName = true : this.firstName = false;
        this.sizeForm.lastName !== '' ? this.lastName = true : this.lastName = false;
        this.sizeForm.address !== '' ? this.address = true : this.address = false;
        // this.sizeForm.apartment !== '' ? this.apartment = true : this.apartment = false;
        this.sizeForm.city !== '' ? this.city = true : this.city = false;
        this.sizeForm.code !== '' ? this.code = true : this.code = false;
        this.sizeForm.phone !== '' ? this.phone = true : this.phone = false;
        // this.sizeForm.discountCode !== '' ? this.discountCode = true : this.discountCode = false
      },
      updateScroll() {
        this.scrollPosition = this.$refs.infoBox.clientHeight - window.scrollY;
      },
      refundShow() {
        this.refund = !this.refund
      },
      validatePromotionCode(e) {
        e.preventDefault();
        this.$store.dispatch('checkout/validatePromoCode', [this.promoCode, this.TotalPrice])
        .then(() => {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.PromoCode = this.PromoCode;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      },
      paymentMethod: "",
      savings: 0,
      GrandTotal: 0,
      Subtotal: 0,
      activeNames: ['1'],
      Subtotal:15,
      total:15,
      sizeForm: {
        name: "",
        subscribe: true,
        firstName: '',
        lastName: '',
        address: '',
        apartment: '',
        city: '',
        code: '',
        phone: '',
        Country: '',
        State: '',
        gateCode: '',
        whether: 1,
        confirmAddress: '',
        Card: '',
        Expiration: '',
        CVC: '',
        storage: true,
      },
      cardData: {
        cardNumber: null,
        expiry: null,
        cvc: null,
        // cardType: null,
        CardName: null,
        salesOrderId: null,
      },
      checkForm: async function(form) {
        this.errors = [];
        if(!form.Street) {
          this.errors.push(this.$t('addressRequired'))
        };
        if(!form.City) {
          this.errors.push(this.$t('cityRequired'))
        };
        if(!form.Country) {
          this.errors.push(this.$t('countryRequired'))
        };
        if(!form.State) {
          this.errors.push(this.$t('stateRequired'))
        };
        if (validateZipCode(form.Zip))(
          this.errors.push(this.$t('zipCodeWrong'))
        );
        if (validatePhoneNumber(form.Telephone))(
          this.errors.push(this.$t('phoneNumberWrong'))
        );
      },
      addBilling() {
        this.isAddBilling = !this.isAddBilling;
        if (this.billingAddress) {
          this.billingAddress = '';
        }
      },
      postNewAddress(form, type, event) {
        event.preventDefault();
        const address = {};
        address.Street = form.address;
        address.City = form.city;
        address.State = form.State;
        address.Zip = form.code;
        address.Country = form.Country;
        address.gateCode = form.gateCode;
        address.FirstName = form.firstName;
        address.LastName = form.lastName;
        address.Telephone = form.phone;
        this.checkForm(address);
        if (!this.errors.length) {
          this.$store.dispatch('addresses/postAddress', [address, type])
          .then(() => {
            this.$store.dispatch('addresses/fetchAddresses');
            this.isAddAddress = false;
            this.isAddBilling = false;
          })
        } else {
          alert(this.errors);
        }
      },
      // not doing anything
      whetherNum(num) {
        console.log(num)
      },
      onSubmit(sizeForm){
        let orderData = {};
        let time = moment()._d;
        orderData.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        orderData.FinalPrice = this.TotalPrice;
        orderData.TotalPrice = this.necessaryCartItems.GrandTotal;
        orderData.GrandTotal = this.necessaryCartItems.GrandTotal;
        orderData.SalesOrder_id = this.salesOrderId;
        orderData.TimeSlot = time;
        orderData.card_reference = this.card_reference; // undefined?
        orderData.PaymentMethod = this.paymentMethod;
        orderData.Billing_CustomerDetail_id = this.addressChoice.CustomerDetail_id;
        orderData.Billing_CustomerDetail_id = this.billingAddressSame ? this.addressChoice.CustomerDetail_id : this.billingAddress.CustomerDetail_id;
        orderData.terminal = this.device;
        orderData.DispatchDate = this.deliveryTime;
        orderData.Deliver_CustomerDetail_id = this.addressChoice.CustomerDetail_id;
        orderData.PromoCode = this.PromoCode || this.necessaryCartItems.PromoCode;
        orderData.Savings = this.Savings;
        for (const key in this.necessaryCartItems) {
          if (!orderData.hasOwnProperty(key)) {
            orderData[key] = this.necessaryCartItems[key];
          }
        }
        if (this.paymentMethod === 'creditcard') {
          if (this.saveCreditCard || this.savedCard) {
            orderData.PaymentMethod = 'saved_card';
          }
          if (this.savedCard.profileId) {
            orderData.existingCard = this.savedCard.profileId;
          } else {
             let cardInfo = {};
            cardInfo.cardNum = this.sizeForm.Card.split(' ').join('')
            cardInfo.expDate = '20' + this.sizeForm.Expiration.split("/").reverse().join("-");
            orderData.cardInfo = cardInfo;
          }
        }
          this.$store.dispatch('checkout/submitOrder', orderData);
      },
      fetchCardToken() {
        let paymentData = {};
        paymentData.cardNum = this.sizeForm.Card.split(' ').join('')
        paymentData.expDate = '20' + this.sizeForm.Expiration.split("/").reverse().join("-");
        paymentData.cvv = this.sizeForm.CVC;
        paymentData.salesOrderId = this.salesOrderId;
        paymentData.card_holder_name = this.sizeForm.card_holder_name;
        // this.$store.dispatch('checkout/fetchACCardToken', paymentData)
        this.$store.dispatch('checkout/saveCreditCard', paymentData)
        if (this.billingAddressSame || this.billingAddress !== '') {
          this.isAddPayment = !this.isAddPayment
        }
      },
      validateAddress() {
        this.$store.dispatch('navbar/validateDeliveryRadius', );
      },
      validateDeliveryRadiusCheckout(event) {
        this.$store.dispatch('navbar/validateDeliveryRadius', this.addressChoice.Zip);
      },
      addAddress() {
        this.isAddAddress = !this.isAddAddress;
      },
      isFormValidForSubmission() {
        let valid = false;
        if (this.paymentMethod === 'creditcard') {
          if (this.cardSuccess) {
            valid = true;
          } else {
            valid = false
          }
        } else if (this.paymentMethod === 'wechatpay' || this.paymentMethod === 'alipay') {
          valid = true;
        }
        if (this.addressChoice === '' || (this.billingAddress === '' && !this.billingAddressSame)) {
          valid = false;
        }
        if (this.orderLoading || this.cardLoading || this.windowOpening) {
          valid = false;
        }
        if (!this.$store.state.cart.cartProductsList.Sales_Order_Lines.length) {
          valid = false;
        }
        if (this.paymentMethod === '') {
          valid = false;
        }
        if (!this.checkoutWithinRadius) {
          valid = false;
        }
        if (this.deliveryTime === '') {
          valid = false;
        }
        return valid;
      },
      goToProductDetail(product) {
        this.updateActiveProduct(product.ProductNum);
        this.$router.push({
          name: 'productDetails',
          query: { productNum: product.ProductNum,
        }})
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
    },
    beforeMount() {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
       this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
       .then(() => {
         this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
       })
      })
      this.$store.dispatch('checkout/fetchTimeSlots');
      this.$store.dispatch('addresses/fetchAddresses');
    },
    watch: {
      IsCreditUsed: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          let cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.IsCreditUsed = this.IsCreditUsed;
          this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
          .then( () => {
             this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          })
        }
      },
      isAddAddress: function (newVal, oldVal) {
        immediate: true;
        if (newVal === true && oldVal === false) {
            this.addressChoice = '';
        }
      },
      addresses: function (newVal, oldVal) {
        if (newVal !== oldVal || newVal.length !== oldVal.length) {
          this.addresses.map(address => {
            if (address.IsDefault) {
              this.addressChoice = address;
              this.addressName = address.FirstName + ' ' + address.LastName;
            }
          });
        }
      },
      addressChoice: function(newVal, oldVal) {
        // reset the error message for payment
        this.showPaymentError = false;

        if (newVal !== oldVal) {
          this.addresses.map(address => {
            if (address.CustomerDetail_id === this.addressChoice.CustomerDetail_id) {
              this.addressName = address.FirstName + ' ' + address.LastName;
            }
          });
        };
        if (oldVal === '' && newVal !== oldVal) {
          this.isAddAddress = false;
        }
      },
      cardLoading: function(newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          this.isAddPayment = false;
        }
      },
      promoCodeSuccessful: function(newVal, oldVal) {
        if (newVal === true) {
         let value = ((this.TotalPrice - this.Savings.toFixed(2)) + this.necessaryCartItems.Tax + this.necessaryCartItems.Delivery).toFixed(2);
         this.saveGrandTotal(Number(value));
        }
      },
      necessaryCartItems: function(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.updatePromoCode(this.necessaryCartItems.Savings);
        }
      },
      billingAddressSame: function(newVal, oldVal) {
        if (!newVal && newVal !== oldVal) {
          this.billingAddress = '';
        }
      },
      cartProductsList: {
        deep: true,
        handler(newVal) {
          if (newVal && this.$route.name === 'purchase') {
            const cartItems = {};
            cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
            cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
            cartItems.ShippingMethod = "Delivery";
            cartItems.Tip = 0;
            cartItems.TipPercentage = 0;
            cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
            this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
            .then(() => {
              this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
            })
            this.clearPromoCode();
            this.IsCreditUsed = false;
            this.clearCard();
          }
        }
      },
      billingAddressSame: function(newVal, oldVal) {
        if (!newVal && newVal !== oldVal) {
          this.billingAddress = '';
        }
      },
      paymentMethod: function(newVal, oldVal) {
        if (newVal === 'creditcard' && newVal !== oldVal) {
          if (this.addresses.length) {
            let id = this.addresses[0].Customer_id
            this.fetchAchProfiles(id);
          }
        }
      },
    },
    beforeRouteLeave(to, from, next) {
       this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
      this.clearPromoCode();
      this.IsCreditUsed = false;
      this.clearCard();
      next();
    },
    computed: mapState({
      salesOrderId: state => state.cart.cartProductsList.SalesOrder_id,
      card_reference: state => state.checkout.card_reference,
      timeSlots: state => state.checkout.timeSlots,
      addresses: state => state.addresses.customerDetails,
      customerDetails: state => state.profile.customerDetails,
      necessaryCartItems: state => state.cart.necessaryCartItems,
      cartProductsList: state => state.cart.cartProductsList,
      device: state => state.navbar.device,
      orderLoading: state => state.checkout.orderLoading,
      orderSuccessful: state => state.checkout.orderSuccessful,
      cardLoading: state => state.checkout.cardLoading,
      cardSuccess: state => state.checkout.cardSuccess,
      cardError: state => state.checkout.cardError,
      checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
      promoCodeLoading: state => state.checkout.promoCodeLoading,
      promoCodeSuccessful: state => state.checkout.promoCodeSuccessful,
      promoCodeError: state => state.checkout.promoCodeError,
      promoCodeValid: state => state.checkout.promoCodeValid,
      PromoCode: state => state.checkout.PromoCode,
      Savings: state => state.checkout.Savings,
      GrandTotal: state => state.checkout.GrandTotal,
      TotalPrice: state => state.checkout.TotalPrice,
      Tax: state => state.checkout.Tax,
      cartClicked: state => state.cart.cartClicked,
      itemCount: state => state.cart.itemCount,
      windowOpening: state => state.checkout.windowOpening,
      orderFailed: state => state.checkout.orderFailed,
      orderFailMessage: state => state.checkout.orderFailMessage,
      savedCards: state => state.checkout.savedCards,
    }),
  }
</script>

<style lang="less">
@import "../assets/css/purchase.less";
@import "../assets/css/animation.less";
</style>



// WEBPACK FOOTER //
// src/view/purchase.vue